export default __webpack_public_path__ + "static/media/vimeo-logo-transparent-white.6df1c2f3.png";